import React, { Component } from 'react';
import { withApollo } from 'react-apollo';

import { UpdateClaim } from '../../../../mutations/UpdateClaim';
import View from './View';

class Comments extends Component {
  state = {};
  handleInputChange = ({ target }) => this.setState({ comment: target.value });

  handleAddComment = () => {
    const { comment } = this.state;
    const {
      id,
      onClaimUpdated,
      hideLoading,
      showLoading,
      client
    } = this.props;
    if (!comment || comment.length === 0) return;
    showLoading();
    client
      .mutate({
        mutation: UpdateClaim,
        variables: {
          input: {
            claim: {
              id
            },
            comment: {
              content: comment
            }
          }
        }
      })
      .then(() => {
        hideLoading();
        onClaimUpdated();
      })
      .catch(() => {
        hideLoading();
      });
  };
  render() {
    return (
      <View
        onInputChange={this.handleInputChange}
        onAddComment={this.handleAddComment}
        {...this.props}
      />
    );
  }
}

export default withApollo(Comments);



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Comments/index.js